export enum TargetEvaluator {
    ALL = "-1",
    SKIP = "-2"
};
